import React, { useRef, useState } from "react";
import {
    I2cInput,
    I2cCheckboxGroup,
    I2cListItem,
    I2cCheckbox, I2cRadioGroup, I2cRadio
} from "@webcomponents/i2cwebcomponents/dist/react";
import "../../PrepaidComponents/Prepaid.scss";
import BasicDataTable from '../../../Components/BasicDataTable/BasicDataTable';
import ErrorMessage from "../../../Components/SharedComponent/ErrorMessage/ErrorMessage";
import { Controller } from "react-hook-form";
import {
    employeeInfoColumnDefs, businessOwnerInfoColumnDefs, businessInfoColumnDefs, loginInfoColumnDefs,
    employeeInfoData,fundOption,paymentGateway
} from './stringUtils';
import AppSelectionIcons from "../AppSelectionForProgram/AppSelectionIcons"

const FundingSourcePrepaid = ({ type, control, handleValueChanges, methods, errors, appSelectionForProgram }) => {
    const checkboxRef = useRef(null);
   
    const handleCheckboxChange = (event, fieldName) => {
        const SelectedNetworkValue = event;
        let updatedSelectedNetworks = [
            ...(methods.getValues(fieldName) ?? []),
        ];
        if (updatedSelectedNetworks.includes(SelectedNetworkValue)) {
            updatedSelectedNetworks = updatedSelectedNetworks.filter(
                (card) => card !== SelectedNetworkValue,
            );
        } else {
            updatedSelectedNetworks.push(SelectedNetworkValue);
        }
        if (
            updatedSelectedNetworks.includes("Credit/Debit Card") &&
            methods.watch("card_enrollment_funding_option_payment_gateway_other")?.length
        ) {
            methods.setValue("card_enrollment_funding_option_payment_gateway_other", "");
        }
        methods.setValue(fieldName, updatedSelectedNetworks);
        methods.trigger();
        handleValueChanges();
    };
    return (
        <>
            <div i2c-grid="grid gap-md" className="section-space">
                <div i2c-grid="12">
                    <div className="sub-heading">
                        <div className="sub-heading">
                            <span className="productIconFlex">
                                <span slot="label" className="organize-tooltip">
                                    Funding Sources
                                </span>
                                <AppSelectionIcons
                                    appSelectionForProgram={appSelectionForProgram}
                                    mobileLink="https://example.com/mobile-app-a"
                                    webLink="https://example.com/web-app-a"
                                />
                            </span>
                        </div>
                    </div>
                </div>
                <div i2c-grid="12">
                    <div className="custom-label-light mb-1-5">
                        Please select the option(s) used to fund /load/ or pay for the card account:
                    </div>
                    <Controller
                        name="card_enrollment_funding_option"
                        control={control}
                        render={({ field }) => (
                            <I2cCheckboxGroup name="card_enrollment_funding_option" ref={checkboxRef}>
                                <div i2c-grid="grid gap-sm">
                                    {fundOption.map((card, index) => (
                                        <div key={index} i2c-grid="12 6@md">
                                            <I2cListItem
                                                variant="receipt"
                                                label={card}
                                                sublabel=""
                                                value=""
                                                type="checkbox"
                                                checked={methods
                                                    .watch("card_enrollment_funding_option")
                                                    .includes(card)}
                                                onI2cCheckboxClicked={(e) =>
                                                    handleCheckboxChange(card, "card_enrollment_funding_option")
                                                }
                                            >
                                                <I2cCheckbox
                                                    slot="prefix"
                                                    value={card}
                                                    label=""
                                                    ignoreTab
                                                    filled
                                                    checked={methods
                                                        .watch("card_enrollment_funding_option")
                                                        .includes(card)}
                                                    className="customCheckbox"
                                                ></I2cCheckbox>
                                            </I2cListItem>
                                        </div>
                                    ))}
                                </div>
                            </I2cCheckboxGroup>
                        )}
                    />
                </div>
                {
                    methods.watch('card_enrollment_funding_option').includes('Credit/Debit Card') && (
                        <>
                            <div i2c-grid="12">
                                <div className="custom-label-light mb-1-5">
                                    If you have selected Credit or Debit card as a funding source, please select the payment gateway that you want to use:
                                </div>
                                <div className="single-field-wrapper">
                                    <Controller
                                        name="card_enrollment_funding_option_payment_gateway"
                                        control={control}
                                        render={({ field }) => (
                                            <I2cRadioGroup
                                                onI2cChange={(e) => {
                                                    methods.setValue("card_enrollment_funding_option_payment_gateway", e.target.value);
                                                    methods.trigger();
                                                    handleValueChanges();
                                                }}
                                            >
                                                <div i2c-grid="grid gap-sm">
                                                    {paymentGateway.map((cpi, index) => (
                                                        <I2cListItem
                                                            key={index}
                                                            i2c-grid="4@md"
                                                            variant="receipt"
                                                            label={cpi}
                                                            sublabel=""
                                                            value=""
                                                            checked={methods.watch("card_enrollment_funding_option_payment_gateway") === cpi}
                                                            type="checkbox"
                                                        >
                                                            <I2cRadio
                                                                slot="prefix"
                                                                name="card_enrollment_funding_option_payment_gateway"
                                                                value={cpi}
                                                                filled
                                                                label=""
                                                                checked={
                                                                    methods.watch("card_enrollment_funding_option_payment_gateway") === cpi
                                                                }
                                                            />
                                                        </I2cListItem>
                                                    ))}
                                                </div>
                                            </I2cRadioGroup>
                                        )}
                                    />
                                </div>
                            </div>
                            {
                                methods.watch("card_enrollment_funding_option_payment_gateway") === "Other" && (
                                    <>
                                        <div i2c-grid="12 6@md">
                                            <div className="single-field-wrapper">
                                                <Controller
                                                    name="card_enrollment_funding_option_payment_gateway_other"
                                                    control={control}
                                                    render={({ field }) => (
                                                        <I2cInput
                                                            {...field}
                                                            label="Specify gateway"
                                                            className="single-input-field"
                                                            placeholder="Enter details"
                                                            onI2cInput={(e) => {
                                                                const value = e.target.value;
                                                                field.onChange(value);
                                                                handleValueChanges();
                                                            }}
                                                            size="large"
                                                            name={"card_enrollment_funding_option_payment_gateway_other"}
                                                        >
                                                        </I2cInput>
                                                    )}
                                                />
                                            </div>
                                        </div>
                                    </>
                                )
                            }
                        </>
                    )
                }
            </div>
        </>
    );
};

export default FundingSourcePrepaid;                  
